import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../helper/shared/shared.service';
import { UserInfoService } from './user-info.service';
import { isNullOrEmpty } from '../helper/validation';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  Header = "User Information";
  ButtonAction = "";
  confirmHeading = "Confirmation";
  confirmBody = 'Do you really want to insert changes?';
  visible = true;
  message = "";

  rep: string = "";
  street: string = "";
  city: string = "";
  state: string = "";
  postal: string = "";
  country: string = "";
  designation: string = "";
  name: string = "";
  error = true;
  errorField: string = "";
  designations: string = "";

  constructor(
    private toastr: ToastrService,
    private sharedService: SharedService,
    private userInfoService: UserInfoService,
  ) { }

  ngOnInit() {
    this.initialize();
    this.sharedService.VisibleSaveClass = "HideSaveClass";    
    this.sharedService.UserInfoMode=true;
    this.sharedService.FromProgramSettings=false;
  }

  initialize(){
    const userId = this.userInfoService.userData.UserId;
    if(userId === 0){
      this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe((result) => {
        if(result !== undefined && result !== null && result !== '') {
          this.userInfoService.InsertUserData(result);
          this.sharedService.RetrieveDDL();
          this.rep = this.userInfoService.userData.Company;
          this.street = this.userInfoService.userData.Street;
          this.city = this.userInfoService.userData.City;
          this.state = this.userInfoService.userData.State;
          this.postal = this.userInfoService.userData.Zip;
          this.country = this.userInfoService.userData.Country;
          this.designation = this.userInfoService.userData.Designation;
          this.name = this.userInfoService.userData.FullName;
        }
      });
    }else{
      this.rep = this.userInfoService.userData.Company;
      this.street = this.userInfoService.userData.Street;
      this.city = this.userInfoService.userData.City;
      this.state = this.userInfoService.userData.State;
      this.postal = this.userInfoService.userData.Zip;
      this.country = this.userInfoService.userData.Country;
      this.designation = this.userInfoService.userData.Designation;
      this.name = this.userInfoService.userData.FullName;
    }
  }

  showDataFromChild(data:any) {
    this.save();
  }

  save(){
  }

}
